import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import RedLogo from "./RedLogo";

const MentorBackgroundPics = ({
  user,
  profile,
  setmentorbio,
  setColor,
  color,
  setEditing,
}) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          {profile &&
          profile.backgroundimageone === "Innovate_Me_logo_red.png" ? (
            <div className="profile-logo-container">
              <RedLogo />
            </div>
          ) : (
            <img
              className={"profile-background-image"}
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/mentors/${profile.backgroundimageone}`}
              alt="background"
            />
          )}
          <div className="profile-user-info">
            {user && user.user === profile.user ? (
              <div
                className="profile-user-info-button-red red"
                onMouseOver={() => setColor(true)}
                onMouseLeave={() => setColor(false)}
              >
                <Link to={`/${user.channelid}/edit`}>
                  <span
                    className={color ? "black" : "red"}
                    onClick={() => setEditing(true)}
                  >
                    Edit Profile
                  </span>
                </Link>
              </div>
            ) : (
              <div
                className="profile-user-info-button-red red"
                onClick={() => setmentorbio(true)}
              >
                Biography
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MentorBackgroundPics;
